import BaseView from '../../base-view';

export default BaseView.extend({
	events: {
		'click .js-tab-list-trigger': 'toggleCollapse'
	},

	initialize: function() {
		this.el.classList.add('tab-list--collapsed');
	},

	toggleCollapse: function() {
		this.el.classList.toggle('tab-list--collapsed');
	}
});
